import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/auth/AuthContext";
import ScrollToHash from "@/components/ScrollToHash";
import RouteSeo from "@/components/RouteSeo";
import ConsentGate from "@/components/ConsentGate";
import { Login, Register } from "@/pages/Auth";
import AdminDashboard from "@/pages/AdminDashboard";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import OurStoryPage from "@/pages/OurStoryPage";
import MeetUsPage from "@/pages/MeetUsPage";
import ServicesIndex from "@/pages/ServicesIndex";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import ContactPage from "@/pages/ContactPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0A0A0A", border: "1px solid rgba(212,175,55,0.25)", color: "#fff" } }} />
        <BrowserRouter>
          <ScrollToHash />
          <RouteSeo />
          <ConsentGate />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/our-story" element={<OurStoryPage />} />
            <Route path="/meet-us" element={<MeetUsPage />} />
            <Route path="/services" element={<ServicesIndex />} />
            <Route path="/services/:slug" element={<ServiceDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
